var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.66406V4.66406C14 3.55949 13.1046 2.66406 12 2.66406H4C2.89543 2.66406 2 3.55949 2 4.66406L2 5.66406M14 5.66406V11.9974C14 13.102 13.1046 13.9974 12 13.9974H4C2.89543 13.9974 2 13.102 2 11.9974L2 5.66406M14 5.66406H2",
    stroke: "#EB5757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66406 8.66406H5.61644M10.3783 8.66406H11.3307M7.52121 8.66406H8.47359",
    stroke: "#EB5757",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66406 11.3359H5.61644M10.3783 11.3359H11.3307M7.52121 11.3359H8.47359",
    stroke: "#EB5757",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.16406 1.83594C5.16406 1.5598 4.9402 1.33594 4.66406 1.33594C4.38792 1.33594 4.16406 1.5598 4.16406 1.83594V3.16927L4.16406 4.5026C4.16406 4.77875 4.38792 5.0026 4.66406 5.0026C4.9402 5.0026 5.16406 4.77875 5.16406 4.5026V3.16927V1.83594Z",
    fill: "#EB5757"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8359 1.83594C11.8359 1.5598 11.6121 1.33594 11.3359 1.33594C11.0598 1.33594 10.8359 1.5598 10.8359 1.83594V3.16927L10.8359 4.5026C10.8359 4.77875 11.0598 5.0026 11.3359 5.0026C11.6121 5.0026 11.8359 4.77875 11.8359 4.5026V3.16927V1.83594Z",
    fill: "#EB5757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.05477bc1fb696924b1fb4298854e5a44.svg";
export { ForwardRef as ReactComponent };